import { createEmptyLine, createTableNoteParagraph } from './docxFunctions'

const SUBJECT_COUNT_RE = /кол-во\s*субъект|субъект/i

/** Примечание под таблицей закупок при &lt; 10 субъектах (из note листа или текста). */
export function createProcurementSubjectsNoteBlocks(layout, goPricing) {
  const blocks = []
  const explicit = String(goPricing?.procurementSubjectsNote || '').trim()
  if (explicit) {
    blocks.push(createTableNoteParagraph(explicit))
    return blocks
  }

  const note = String(layout?.note || '').trim()
  if (!note) return blocks

  const tableRows = layout?.tableRows || []
  const headerRow = tableRows[0] || []
  let subjectCol = -1
  headerRow.forEach((cell, idx) => {
    if (cell?.hidden) return
    const t = String(cell?.value || '')
    if (SUBJECT_COUNT_RE.test(t)) subjectCol = idx
  })

  if (subjectCol < 0) return blocks

  const counts = []
  for (let r = 1; r < tableRows.length; r++) {
    const row = tableRows[r] || []
    const cell = row[subjectCol]
    if (!cell || cell.hidden) continue
    const raw = String(cell.value || '').trim().replace(/\s/g, '')
    const n = Number(raw.replace(',', '.'))
    if (Number.isFinite(n)) counts.push(n)
  }

  const maxSubjects = counts.length ? Math.max(...counts) : 0
  if (maxSubjects >= 10) return blocks

  if (/субъект/i.test(note)) {
    blocks.push(createTableNoteParagraph(note))
  }

  return blocks
}

export function appendProcurementNotesToBlocks(blocks, layout, goPricing) {
  const notes = createProcurementSubjectsNoteBlocks(layout, goPricing)
  return [...blocks, ...notes, createEmptyLine()]
}
